import { InputField, InputSelectOptions, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { SCOPE } from 'domains/finance/payments/constants'

const propTypes = {
  filterValues       : PropTypes.object.isRequired,
  onClickSubmitForm  : PropTypes.func.isRequired,
  onClickReset       : PropTypes.func.isRequired,
  showCustomerFields : PropTypes.bool
}

/**
 * Form to filters Payment data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset form
 * @param {Array<String>} hiddenColumns - Array of hidden columns name so we can hide unnecessary filter
 */

const FinancePaymentsFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset
}) => (
  <Formik
    initialValues={{
      q: filterValues.q || '',
      scope: filterValues.scope || SCOPE.NEED_ACTION,
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      (formikProps) => (
        <Form>
          <ListGroup>

            <ListGroupItem>
              <InputField
                key={ 'finance-payments-filter-form-field-q' }
                type='text'
                name={ 'q' }
                label={ 'Query' }
                placeholder={ 'Cari reference number' }
                bsSize={ 'md' }
              />
            </ListGroupItem>

            <ListGroupItem>
              <InputField
                key={ 'request-pickup-filter-form-field-scope' }
                type='select'
                name={ 'scope' }
                label={ 'Status' }
                bsSize={ 'md' }
              >
                <InputSelectOptions options={ SCOPE } />
              </InputField>
            </ListGroupItem>

            <div className='d-flex justify-content-center position-sticky fixed-bottom bg-white py-3'>
              <LoaderButton
                color='primary'
                className='mt-auto'
                type='submit'
                disabled={ formikProps.isSubmitting }
                isLoading={ formikProps.isSubmitting }
                text='Filter'
              />
              <LoaderButton
                color='danger'
                disabled={ formikProps.isSubmitting }
                isLoading={ formikProps.isSubmitting }
                text='Reset'
                onClick={ onClickReset }
              />
            </div>

          </ListGroup>
        </Form>
      )
    }

  </Formik>
)

FinancePaymentsFilterForm.propTypes = propTypes

export default FinancePaymentsFilterForm
